
import { uploadFileToOss } from '@/utils/upload';
import { toBlob } from 'html-to-image';
import { enterprise } from '@/axios/interface';
import instance from '@/axios';
import { resolvePageId } from '@rebuild/utils/context';

const doReload = () => {
	window.location.reload();
};

export const screenShot = async (options = {}) => {
    try {
        // 等待目标元素存在
        const element = document.querySelector('.layout-container');

        console.log('开始截取元素...', element);

        if (!element) {
            throw new Error('找不到目标元素 .layout-container');
        }

        // 检查元素是否包含图片
        const images = element.querySelectorAll('img');
        console.log('元素中包含的图片数量:', images.length);
        
        // 记录原始图片状态
        const originalImages = [];
        images.forEach((img, index) => {
            originalImages[index] = {
                src: img.src,
                style: img.style.cssText
            };
            
            if (!img.complete || img.naturalHeight === 0) {
                console.warn('发现未加载图片，设置占位符:', img.src);
                // 使用简单的灰色占位符图片
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
                img.style.background = '#f5f5f5';
                img.style.border = '1px solid #ddd';
                img.style.minWidth = '200px';
                img.style.minHeight = '150px';
                img.style.display = 'block';
            }
        });
        
        // 清理DOM中的无效选择器
        const modifiedAttributes = [];
        
        try {
            const allElements = element.querySelectorAll('*');
            allElements.forEach(el => {
                // 备份并清理无效ID
                if (el.id && (el.id.includes('#') || el.id.includes(' ') || el.id === '' || el.id.startsWith('#'))) {
                    console.warn('清理无效ID:', el.id);
                    modifiedAttributes.push({
                        element: el,
                        attribute: 'id',
                        originalValue: el.id
                    });
                    el.removeAttribute('id');
                }
                
                // 备份并清理包含特殊字符的href属性
                if (el.hasAttribute('href') && el.getAttribute('href').includes('#')) {
                    const originalHref = el.getAttribute('href');
                    if (originalHref.startsWith('#') && originalHref.length > 1) {
                        // 如果是锚点链接，记录并移除
                        console.warn('清理锚点链接:', originalHref);
                        modifiedAttributes.push({
                            element: el,
                            attribute: 'href',
                            originalValue: originalHref
                        });
                        el.removeAttribute('href');
                    }
                }
                
                // 清理xlink:href属性
                if (el.hasAttribute('xlink:href')) {
                    const originalXlinkHref = el.getAttribute('xlink:href');
                    console.warn('清理xlink:href:', originalXlinkHref);
                    modifiedAttributes.push({
                        element: el,
                        attribute: 'xlink:href',
                        originalValue: originalXlinkHref
                    });
                    el.removeAttribute('xlink:href');
                }
            });
        } catch (e) {
            console.warn('DOM清理过程中出现错误，跳过清理:', e);
        }

        console.log('图片状态检查完成，DOM清理完成，开始截图');

        // 性能优化：缓存Canvas检查结果，避免重复调用toDataURL
        const canvasCheckCache = new WeakMap();
        
        // 性能优化：限制最大截图高度，避免超大Canvas
        const maxHeight = 2000; // 限制最大高度为2000px
        const calculatedHeight = Math.max(element.offsetHeight * 0.4, 1000);
        const finalHeight = Math.min(calculatedHeight, maxHeight);
        
        // 性能优化：根据设备性能动态设置pixelRatio
        const devicePixelRatio = window.devicePixelRatio || 1;
        const optimalPixelRatio = devicePixelRatio > 2 ? 1.5 : devicePixelRatio; // 限制最大为1.5
        
        const blob = await toBlob(element, {
            width: element.offsetWidth,
            height: finalHeight,
            backgroundColor: '#fff', // 设置默认白色背景
            pixelRatio: optimalPixelRatio, // 优化：降低pixelRatio减少内存和计算量
            quality: 0.8, // 优化：降低质量到0.8，平衡质量和性能
            skipFonts: true, // 优化：跳过字体处理，提升性能
            useCORS: true, // 启用CORS支持
            allowTaint: true, // 不允许跨域图片污染画布
            filter: (node) => {
                // 过滤掉可能导致污染的元素
                if (node.nodeType === Node.ELEMENT_NODE) {
                    const el = node;
                    
                    // 只跳过有问题的Canvas元素
                    if (el.tagName === 'CANVAS') {
                        const canvas = el;
                        // 检查Canvas是否有问题
                        if (canvas.width === 0 || canvas.height === 0) {
                            console.warn('跳过0尺寸Canvas元素');
                            return false;
                        }
                        // 性能优化：使用缓存避免重复调用toDataURL
                        if (canvasCheckCache.has(canvas)) {
                            return canvasCheckCache.get(canvas);
                        }
                        // 检查Canvas是否被污染
                        try {
                            // 优化：使用更轻量的检查方式，只检查是否可读取
                            const context = canvas.getContext('2d', { willReadFrequently: false });
                            if (!context) {
                                canvasCheckCache.set(canvas, false);
                                return false;
                            }
                            // 如果必须检查污染，可以尝试读取一个像素而不是整个toDataURL
                            try {
                                context.getImageData(0, 0, 1, 1);
                                canvasCheckCache.set(canvas, true);
                                return true; // Canvas正常，保留
                            } catch (e) {
                                console.warn('跳过被污染的Canvas元素:', e.message);
                                canvasCheckCache.set(canvas, false);
                                return false; // Canvas被污染，跳过
                            }
                        } catch (e) {
                            console.warn('Canvas检查失败:', e.message);
                            canvasCheckCache.set(canvas, false);
                            return false;
                        }
                    }
                    
                    // 跳过0尺寸元素
                    if (el.offsetWidth === 0 || el.offsetHeight === 0) {
                        return false;
                    }
                }
                return true;
            }
        })

        // 恢复被修改的属性
        modifiedAttributes.forEach(({ element, attribute, originalValue }) => {
            try {
                element.setAttribute(attribute, originalValue);
            } catch (e) {
                console.warn('恢复属性失败:', attribute, e);
            }
        });

        // 恢复原始图片状态
        images.forEach((img, index) => {
            if (originalImages[index]) {
                img.src = originalImages[index].src;
                img.style.cssText = originalImages[index].style;
            }
        });
        console.log('所有状态已恢复');

        // 方法1: 将blob转换为File对象
        const file = new File([blob], 'screenshot.png', {
            type: blob.type || 'image/png'
        });

        // 上传到OSS
        uploadFileToOss(file, null, true).then(res => {
            const { viewurl = ''} = res.data
            instance.post(enterprise.saveScreenshotImage, {
                imageUrl: viewurl,
                pageId: resolvePageId(),
            },{
                Token: options.token
            }).then(res => {
                console.log("🚀 ~ screenShot ~ saveScreenshotImage res:", res);
                doReload();
            }).catch(err => {
                console.error("保存截图失败:", err);
            });
        }).catch(err => {
            doReload();
            console.error("上传失败:", err);
        });
    } catch (error) {
        doReload();
        console.error('截图失败:', error);
        throw error;
    }
};

